export default {"src":"/_next/static/media/alaram-clock.c372b34a.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};